// extracted by mini-css-extract-plugin
export var buttons = "_af-0";
export var buttonsActive = "_af-h";
export var cancelConfirm = "_af-1";
export var closeButton = "_af-2";
export var column = "_af-3";
export var container = "_af-4";
export var detailHeader = "_af-6";
export var detailTitle = "_af-7";
export var detailsContent = "_af-5";
export var header = "_af-8";
export var headerWithClose = "_af-9";
export var icon = "_af-a";
export var infoIcon = "_af-c";
export var informationContainer = "_af-b";
export var sideDrawer = "_af-d";
export var sideDrawerOpen = "_af-e";
export var stickyFooter = "_af-f";
export var typeOption = "_af-g";